/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';
import { amountComparator } from '../../../../SharedModules/utilities/utilities';

export const manuFactureHead = [
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    sort: 'asc',
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const drugFamilyTableData = [
  {
    headerName: 'Drug Family ID',
    field: 'familySeqNum',
    editable: false,
    minWidth: Styles.Width_200,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    sortingOrder: ['desc', 'asc'],
    excelAlignment: 'right',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Drug Family Name',
    field: 'familyName',
    editable: false,
    sortable: true,
    resizable: false,
    suppressMenu: false,
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const rebatePricingDetails = [
  {
    headerName: 'Rebate Pricing Method',
    field: 'rebatepricingmethod',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_180,
    suppressMenu: false,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Volume Calc Method',
    field: 'valumecalcmethod',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_180,
    resizable: true,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    suppressMenu: false,
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Market Share Calc Method',
    field: 'marketsharecalcmethod',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_200,
    resizable: true,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    suppressMenu: false,
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'National Mkt Share Price',
    field: 'nationalmarketshareprice',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_200,
    resizable: false,
    suppressMenu: false,
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const hideColumns = ['action'];
export const priceDetailsHeaders = [
  {
    headerName: 'Comments Exists',
    field: 'claimCorrLinkId',
    hideFilterIcon: true,
    editable: false,
    sortable: false,
    minWidth: Styles.Width_150,
    enableMenu: false,
    showCheckboxIcon: true,
    resizable: true,
    maxWidth: Styles.Width_250,
    cellRenderer: 'ActionCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    cellClass: 'ag-cell-action frr-overflow-visible',
  },
  {
    headerName: 'Level ID',
    field: 'levelId',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_80,
    cellRenderer: 'TextBoxRender',
    maxLength: 10,
    isNumber: true,
    resizable: true,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Amount',
    field: 'amt',
    editable: false,
    sortable: true,
    printPrefixValue: '$ ',
    exportZeroesTwo: true,
    minWidth: Styles.Width_100,
    cellRenderer: 'TextBoxRender',
    sortingOrder: ['asc', 'desc'],
    comparator: amountComparator,
    cellClass: 'frr-amount-prefix',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    cellEditor: MaxLengthNumericEditor,
    maxLength: 15,
    isNumber: true,
    resizable: true,
    filter: 'agTextColumnFilter',
    dataAlignRight: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Start Quarter',
    field: 'startQtr',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_100,
    cellRenderer: 'TextBoxRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    cellEditor: MaxLengthNumericEditor,
    maxLength: 6,
    isNumber: true,
    resizable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'End Quarter',
    field: 'endQtr',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_100,
    cellRenderer: 'TextBoxRender',
    cellEditor: MaxLengthNumericEditor,
    maxLength: 6,
    isNumber: true,
    resizable: false,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
